'use memo';

import {
  AgxButton,
  AgxSpacer,
  AgxTypography,
  Icon_Arrow,
  Icon_CheckmarkOutline,
  Icon_EditOutline,
  Icon_Link,
  Icon_FileTextOutline,
  Icon_Refresh,
  Icon_ListOutline,
} from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import Panel from 'components/panel/Panel';
import { useNavigate } from 'react-router-dom';
import { StaffRole } from '@urbanx/agx.auth.client';
import { useDoesUserHasRequiredRoles } from 'helpers/doesUserHaveRequiredRoles';

const SupportTools = () => {
  const navigate = useNavigate();
  const doesUserHaveRequiredRoles = useDoesUserHasRequiredRoles();
  const canUseManualDocuSignUpdates = doesUserHaveRequiredRoles([StaffRole.SuperAdmin]);

  return (
    <AgxSpacer direction="horizontal" gap="spacing-xl" fill style={{ flexWrap: 'wrap' }}>
      <Panel
        title="Service queues"
        actionContent={
          <AgxButton
            id="support-service-queues-link"
            text="Open"
            variant="primary"
            size="small"
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_QUEUES)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-service-queues-summary" type="body" size="small">
            Queue failures and message replay
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Migrations"
        actionContent={
          <AgxButton
            id="support-migrations-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Refresh width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_MIGRATIONS)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-migrations-summary" type="body" size="small">
            Migration status and manual runs
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Update Legal Name"
        actionContent={
          <AgxButton
            id="support-update-legal-name-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_EditOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_UPDATE_LEGAL_NAME)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-update-legal-name-summary" type="body" size="small">
            Campaign vendor legal-name updates
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Update Campaign Status"
        actionContent={
          <AgxButton
            id="support-update-campaign-status-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_CheckmarkOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_UPDATE_CAMPAIGN_STATUS)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-update-campaign-status-summary" type="body" size="small">
            Campaign stage override updates
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Task Progressor"
        actionContent={
          <AgxButton
            id="support-task-progressor-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_ListOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_TASK_PROGRESSOR)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-task-progressor-summary" type="body" size="small">
            Staff task initialisation and workflow progression
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="CRM Support"
        actionContent={
          <AgxButton
            id="support-crm-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Link width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_CRM)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-crm-summary" type="body" size="small">
            CRM resyncs and operational support
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Restore Soft Deleted Agent"
        actionContent={
          <AgxButton
            id="support-restore-soft-deleted-agent-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Refresh width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            onClick={() => navigate(Pages.SUPPORT_RESTORE_SOFT_DELETED_AGENT)}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-restore-soft-deleted-agent-summary" type="body" size="small">
            Restore agents by clearing their soft-deleted flag
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      {canUseManualDocuSignUpdates && (
        <Panel
          title="Manual DocuSign Updates"
          actionContent={
            <AgxButton
              id="support-manual-docusign-updates-link"
              text="Open"
              variant="primary"
              size="small"
              leftIcon={<Icon_FileTextOutline width={16} height={16} />}
              rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
              onClick={() => navigate(Pages.SUPPORT_MANUAL_DOCUSIGN_UPDATES)}
            />
          }
          halfWidth
        >
          <AgxSpacer gap="spacing-sm">
            <AgxTypography id="support-manual-docusign-updates-summary" type="body" size="small">
              Manual envelope and recipient signing updates
            </AgxTypography>
          </AgxSpacer>
        </Panel>
      )}
    </AgxSpacer>
  );
};

export default SupportTools;
